import { ReactNode } from 'react';
import classnames from 'classnames';

export type CommonInputProps = {
  error?: string;
};

type BaseInputChildrenProps = {
  className: string;
};

type Props = CommonInputProps & {
  children(props: BaseInputChildrenProps): ReactNode;
};

export function BaseInput({ children, error }: Props) {
  return (
    <div>
      {children({
        className: classnames(
          'block w-full rounded-lg border border-slate-300 bg-white px-3 py-2.5 text-sm font-normal text-slate-900 shadow-sm transition placeholder:text-slate-400 focus:border-red-500 focus:outline-none focus:ring-4 focus:ring-red-100 disabled:cursor-not-allowed disabled:bg-slate-50 disabled:text-slate-500',
          {
            'border-rose-500 bg-rose-50/40 text-rose-900 focus:border-rose-500 focus:ring-rose-100':
              error,
          },
        ),
      })}
      {error && (
        <div className="mt-1 text-xs font-medium text-rose-600">
          {error}
        </div>
      )}
    </div>
  );
}
